import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconNowAvailable = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m1-16a1 1 0 1 0-2 0v5H9a1 1 0 1 0 0 2h2a2 2 0 0 0 2-2z", clipRule: "evenodd" }) });
const ForwardRef = forwardRef(SvgIconNowAvailable);
export default ForwardRef;
